// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import FlagIcon from '../../../components/FlagIcon';
import MatchChip from '../../../components/MatchChip';
import { __ } from '../../../i18n/l10n';
import colors from '../../../styled-components/palette';
import { BetslipStatus } from '../../../types/history';

import HallOfFameBetslips from './HallOfFameBetslips';
import HallOfFameItemSummary from './HallOfFameItemSummary';

const Wrapper = styled.div`
  background: ${colors.bluegrey900};
  padding: 0.6em;
  border-radius: 1em;
  margin-bottom: 0.625em;
`;

export const Card = styled.div`
  background: ${colors.bluegrey900};
  box-shadow: 0 0 0.625em 0 rgba(0, 0, 0, 0.75);
  border-radius: 0.625em;
  margin-bottom: 0.625em;
  padding: 0.625em 0.625em 0.3em;
`;

const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.625em;
`;

const HallOfFameItemSummaryStyled = styled(HallOfFameItemSummary)`
  margin-top: 1em;
`;

const MultiHeader = styled.div`
  margin: 0 0.625em 0.625em;
`;

const UserChip = styled(MatchChip)``;

const UserFlag = styled(FlagIcon)`
  height: 100%;
  width: 100%;
`;

const Badges = styled.div`
  display: flex;
  margin-left: auto;
`;

const Badge = styled.div`
  border-radius: 0.375em;
  font-size: 0.75em;
  font-weight: bold;
  margin-left: 0.6em;
  padding: 0.1em 0.3em;
  background: ${colors.yellowwinamax500};
`;

type HallOfFameItemProps = {
  betslip: {
    betslipId: string;
    type: string;
    status: BetslipStatus;
    winningsAmount: number;
    winningsBonus: number;
    possibleWinnings: number;
    possibleBonus: number;
    globalOdds: number;
    details: Array<{ isLive: boolean }>;
    betAmount: number;
    freebet: boolean;
    promotionTitle: string;
    nickname: string;
    userLicense: string;
  };
};

const HallOfFameItem = ({ betslip }: HallOfFameItemProps) => {
  const {
    betslipId,
    type,
    status,
    winningsAmount,
    winningsBonus,
    possibleWinnings,
    possibleBonus,
    globalOdds,
    details,
    betAmount,
    freebet,
    promotionTitle,
    nickname,
    userLicense,
  } = betslip;

  const isSimpleBet = details.length === 1;
  const { isLive } = details && details[0];
  const isCashout = status === BetslipStatus.CASHOUT;

  const headerCard = useMemo(
    () => (
      <Header>
        {nickname ? (
          <UserChip icon={userLicense ? <UserFlag flagId={userLicense} /> : null}>{nickname}</UserChip>
        ) : null}
        <Badges>
          {isLive && isSimpleBet ? <Badge>{__('In Play')}</Badge> : null}
          {isCashout ? <Badge>{__('Cashout')}</Badge> : null}
        </Badges>
      </Header>
    ),
    [isLive, isCashout, isSimpleBet, userLicense, nickname],
  );

  const betsLips = useMemo(
    () => (
      <HallOfFameBetslips
        betslipId={betslipId}
        details={details}
        status={status}
        isSimpleBet={isSimpleBet}
        isLive={isLive}
      />
    ),
    [betslipId, details, isLive, isSimpleBet, status],
  );

  return (
    <Wrapper isSimpleBet={isSimpleBet}>
      {isSimpleBet ? (
        <Card>
          {headerCard}
          {betsLips}
        </Card>
      ) : (
        <MultiHeader>
          {headerCard}
          {betsLips}
        </MultiHeader>
      )}

      <HallOfFameItemSummaryStyled
        freebet={freebet}
        betAmount={betAmount}
        type={type}
        globalOdds={globalOdds}
        details={details}
        status={status}
        winningsAmount={winningsAmount}
        winningsBonus={winningsBonus}
        promotionTitle={promotionTitle}
        possibleWinnings={possibleWinnings}
        possibleBonus={possibleBonus}
      />
    </Wrapper>
  );
};

export default HallOfFameItem;
